import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { ThemeProvider } from './contexts/ThemeContext'
import { AppProvider } from './contexts/AppContext'
import Layout from './components/layout/Layout'
import HomePage from './pages/HomePage'
import TicTacToePage from './pages/TicTacToePage'
import Game2048Page from './pages/Game2048Page'
import NotFoundPage from './pages/NotFoundPage'

function App() {
  return (
    <ThemeProvider>
      <AppProvider>
        <Router>
          <Layout>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/tic-tac-toe" element={<TicTacToePage />} />
              <Route path="/2048" element={<Game2048Page />} />
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
          </Layout>
        </Router>
      </AppProvider>
    </ThemeProvider>
  )
}

export default App